export default __webpack_public_path__ + "static/media/cssnext.7cfaaf2e.svg";